export function parseTime(time: string | null): [hours: number, minutes: number] {
  if (!time) return [0, 0]
  const [hours, minutes] = time.split(':')

  let parsedHours = parseInt(hours)
  if (parsedHours < 0 || isNaN(parsedHours)) parsedHours = 0
  if (parsedHours > 23) parsedHours = 23

  let parsedMinutes = parseInt(minutes)
  if (parsedMinutes < 0 || isNaN(parsedMinutes)) parsedMinutes = 0
  if (parsedMinutes > 59) parsedMinutes = 59

  return [parsedHours, parsedMinutes]
}
